import area from "@/assets/js/area.json";
import area_i18n from "@/assets/js/area_i18n.json";

let res = area;
if(process.env.VUE_APP_i18n){
  res = area_i18n
}
export default { ...res } 
